<template>
<div id="basket-component">
	<div id="tableConfigureModal" class="modal fade" tabindex="-1" role="dialog">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<button type="button" class="close" @click.prevent="cancelTableConfiguration">
					<span>&times;</span>
					</button>
					<h4 class="modal-title">
					Resampling options: <b>{{editedTable.table}}</b>
					<small>({{editedTable.display}})</small>
					</h4>
				</div>
				<div class="modal-body">
					<div class="form form-horizontal">
						<div class="form-group form-group-sm">
							<label class="control-label col-sm-4">Start date</label>
							<div class="col-sm-8">
								<Datepicker
								placeholder="Start date"
								v-model="tableStart"
								:format="format"
								autoApply>
								</Datepicker>
							</div>
						</div>
						<div class="form-group form-group-sm">
							<label class="control-label col-sm-4">End date</label>
							<div class="col-sm-8">
								<Datepicker
								placeholder="End date"
								v-model="tableEnd"
								:format="format"
								autoApply>
								</Datepicker>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button
					type="button"
					class="btn btn-default"
					@click.prevent="cancelTableConfiguration">
					Close
					</button>
					<button
					type="button"
					class="btn btn-primary">
					Save changes
					</button>
				</div>
				</div><!-- /.modal-content -->
				</div><!-- /.modal-dialog -->
				</div><!-- /.modal -->
				<div class="panel panel-default">
					<div class="panel-heading">
						<span class="panel-title">Basket</span>
						<div class="pull-right">
							<a 	href="#" class="text-muted">
								<span class="glyphicon glyphicon-share-alt"></span>
							</a>
							<a 	href="#"
								@click.prevent="clearBasket">
								<span class="glyphicon glyphicon-remove"></span>
							</a>
							<a
								href="#"
								@click.prevent="executeBasket">
								<span class="glyphicon glyphicon-play"></span>
							</a>
						</div>
					</div>
					<div class="panel-body">
						<div class="alert alert-warning" v-if="basketErrorMessage">
							Error while loading data: {{basketErrorMessage}}
						</div>
						<p v-show="cartIsEmpty" class="text-muted">Selection is empty</p>
						<table v-if="!cartIsEmpty" class="table table-condensed table-hover">
							<thead>
								<tr>
									<th>Table</th><th>Version</th><th></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="version in basket" :key="version.display">
									<td>{{version.table}}</td>
									<td>{{version.display}}</td>
									<td>
										<a
											href="#"
											alt="configure"
											@click.prevent="configureTable(version)">
											<span class="glyphicon glyphicon-cog"></span>
										</a>
										<a
											href="#"
											alt="remove from basket"
											@click.prevent="removeFromCart(version)">
											<span class="glyphicon glyphicon-trash"></span>
										</a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="panel-footer" v-show="basketMultiSelect">
						<h5>Pre-resampling</h5>
						<div class="form-horizontal">
						<aggregation-picker v-model="preMethod" label="Method"></aggregation-picker>
						<resample-picker v-model="preStep" label="Step"></resample-picker>
					</div>
				</div>
				<div class="panel-footer">
					<h5 v-if="basketMultiSelect">Post-resampling</h5>
					<h5 v-else>Resampling</h5>
					<div class="form-horizontal">
					<aggregation-picker v-model="postMethod" label="Method"></aggregation-picker>
					<resample-picker v-model="postStep" label="Step"></resample-picker>
				</div>
			</div>
			<div class="panel-footer" v-show="basketMultiSelect">
				<h5>Global</h5>
				<div class="form-horizontal">
				<aggregation-picker v-model="globalMethod" label="Aggregation"></aggregation-picker>
			</div>
		</div>
	</div>
</div>
</template>
<script type="text/javascript">

import AggPicker from './AggregationPicker.vue'
import ResamplePicker from './ResamplePicker.vue'

export default {
	data() {
		return {
			postMethod: this.$store.state.basket.postResample.method,
			postStep: this.$store.state.basket.postResample.step,

			preMethod: this.$store.state.basket.preResample.method,
			preStep:  this.$store.state.basket.preResample.step,

			globalMethod: this.$store.state.basket.aggregationMethod,

			tableStart: '',
			tableEnd: '',
			format: "yyyy-MM-dd",
		}
	},
	mounted() {
		this.$watch(() => {
			return this.$store.state.basket.editedTable
		}, (state) =>{
			if(state) {
				$('#tableConfigureModal').modal({show: true, modal: 'static'})
			} else {
				$('#tableConfigureModal').modal('hide')
			}
		})
	},
	components: {
		'aggregation-picker': AggPicker,
		'resample-picker': ResamplePicker
	},
	methods: {
		executeBasket() {
			this.$store.dispatch("executeBasket")
		},
		clearBasket() {
			this.$store.dispatch("clearCart")
		},
		removeFromCart(version) {
			this.$store.dispatch("removeFromCart", version)
		},
		configureTable(version) {
			this.$store.dispatch("configureTable", version)
		},
		saveTableConfiguration() {

		},
		cancelTableConfiguration() {
			this.$store.dispatch("cancelTableConfiguration")
		}
	},
	computed: {
		basket() {
			return this.$store.state.basket.cart
		},
		basketErrorMessage() {
			return this.$store.state.basket.errorMessage
		},
		cartIsEmpty() {
			return !(this.$store.state.basket.cart.length > 0)
		},
		editedTable() {
			return this.$store.state.basket.editedTable || {table: '', version: ''}
		},
		editMode() {
			return this.editedTable.table || false
		},
		basketMultiSelect() {
			return (this.$store.state.basket.cart.length > 1)
		}
	},
	watch: {
		preMethod(value){
			if (value) {
				var args = {method: value, step: this.preStep}
			} else {
				var args = {method: null, step: null}
			}
			this.$store.dispatch("setPreResample", args)
		},
		preStep(value){
			if (this.preMethod) {
				var args = {method: this.preMethod, step: value}
			} else {
				var args = {method: null, step: null}
			}
			this.$store.dispatch("setPreResample", args)
		},
		postMethod(value){
			if (value) {
				var args = {method: value, step: this.postStep}
			} else {
				var args = {method: null, step: null}
			}
			this.$store.dispatch("setPostResample", args)
		},
		postStep(value){
			if (this.postMethod) {
				var args = {method: this.postMethod, step: value}
			} else {
				var args = {method: null, step: null}
			}
			this.$store.dispatch("setPostResample", args)
		},
		globalMethod(value) {
			this.$store.dispatch("setGlobalAggregationMethod", value)
		}
	}
}

</script>
